/*
Documentation

this file is used to set the code formatting styles

*/

import { nord } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export const CodeStyle = nord;